import React from "react";
import { TbRefresh } from "react-icons/tb";
import { resetTable } from "../../utils/helpers";

/**
 * ResetTableButton Component
 * 
 * Button to reset datatable to initial state by clearing all filters, sorts,
 * hidden fields, and search. Disabled during data loading. Provides visual feedback
 * with loading state styling.
 * 
 * @param {Object} props - Component props
 * @param {boolean} props.isLoading - Loading state (disables button when true)
 * @returns {JSX.Element} Reset button with icon and label
 */
const ResetTableButton = ({ props }) => {
  const { isLoading } = props;
  return (
    <div
      className={
        isLoading
          ? "disabled shutdowndatahidefieldbutton flex-center gap-2"
          : "shutdowndatahidefieldbutton flex-center gap-2"
      }
      data-tip="Reset table"
      onClick={!isLoading ? (e) => resetTable(e, props) : () => { }}
    >
      <TbRefresh size={"1.2rem"} />
      <span className="desktop">Reset</span>
    </div>
  );
};

export default ResetTableButton;
